class ConstantsType {
  static readonly task_type_clean_1: number = 1; //子任务类型：1-表示清洗路径 2-功能点

  static readonly task_status_default_0: number = 0; //任务状态，0-未执行 １-执行中 2-已结束 3-已暂停
  static readonly task_status_over_2: number = 2; //任务状态，0-未执行 １-执行中 2-已结束 3-已暂停
  static readonly task_status_ing_1: number = 1; //任务状态，0-未执行 １-执行中 2-已结束 3-已暂停
  static readonly task_status_pause_3: number = 3; //任务状态，0-未执行 １-执行中 2-已结束 3-已暂停

  static readonly supply_status_ing_1: number = 1; //补给任务状态 １-补给中
  static readonly floor_task_status_ing_1: number = 1; //任务状态，1-执行中，2-正常结束，3-异常结束，4-暂停中, 5-用户主动结束
  static readonly floor_task_status_pause_4: number = 4; //任务状态，1-执行中，2-正常结束，3-异常结束，4-暂停中, 5-用户主动结束
  static readonly supply_status_duijie_3: number = 3; //补给任务状态 １-对接成功

  static readonly supply_internet_connect_offline = 0; // 离线模式
  static readonly supply_internet_connect_only = 1; // 独享模式
  static readonly supply_internet_connect_together = 2; // 共享模式
}

export default ConstantsType;
